module.exports = __webpack_public_path__ + "img/func-detail-3.2079bb7d.png";